import { useEffect, useState } from "react";
import GenerateTicketsModal from "../../components/Modals/GenerateTicketsModal";
import CustomerTicket from "../../components/Modals/CustometTicketModel";
import UpdateTicketsStatus from "../../components/Modals/UpdateTicketStatus";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";
import NoData from "../../components/NoData";
import {
  Accordion,
  Dropdown,
  DropdownButton,
  Form,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader";
import { useLocation } from "react-router-dom";
import ImportModal from "../../components/Modals/ImportModel";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaDownload,
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
} from "react-icons/fa";
import ExportModal from "../../components/Modals/ExportsModel/main";
import moment from "moment";
import TicketViewModal from "../../components/Modals/TicketViewModel";

import Pagination from "../../components/Pagination";
import CommonButton from "../../components/CommonButton";
import StatusBadge from "../../components/StatusBadge";

function Tickets() {
  const location = useLocation();

  const [showTicketModal, setShowTicketModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [editTicketData, setEditTicketData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [ticketAction, setTicketAction] = useState("");
  const [selectedTicketIds, setSelectedTicketIds] = useState([]);
  const [allTicketIds, setAllTicketIds] = useState([]);
  const userRole = localStorage.getItem("role");
  const userPermissions = localStorage.getItem("user_permissions");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [filtersReady, setFiltersReady] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredTickets.slice(itemOffset, endOffset);

  const TicketComponent =
    userRole === "customer" || userRole === "subcustomer"
      ? CustomerTicket
      : GenerateTicketsModal;

  useEffect(() => {
    const searchParams = new URLSearchParams(location?.search);
    const statusFromQuery = searchParams.get("status");
    const idFromQuery = searchParams.get("id");

    if (statusFromQuery !== null) {
      setStatusFilter(statusFromQuery);
    } else {
      setStatusFilter("");
    }

    if (idFromQuery !== null) {
      setFilterType("ticketid");
      setFilterValue(idFromQuery);
    } else {
      setFilterType("");
      setFilterValue("");
    }

    setFiltersReady(true);
  }, [location]);

  useEffect(() => {
    if (filtersReady) {
      fetchTickets(currentPage);
    }
  }, [
    filtersReady,
    statusFilter,
    filterType,
    filterValue,
    itemsPerPage,
    currentPage,
  ]);

  useEffect(() => {
    if (filtersReady) {
      fetchAllTicketIds();
    }
  }, [filtersReady, statusFilter, filterType, filterValue]);

  const fetchTickets = async (page = 1) => {
    setLoading(true);
    try {
      const queryParams = {
        page,
        page_size: itemsPerPage,
        status: statusFilter || undefined,
      };

      if (filterType && filterValue) {
        switch (filterType) {
          case "ticketid":
            queryParams.id = filterValue;
            break;
          case "taskName":
            queryParams.task_name = filterValue;
            break;
          case "customer_name":
            queryParams.cust_name = filterValue;
            break;
          case "subcustomer_name":
            queryParams.subcust_name = filterValue;
            break;
          case "phone_number":
            queryParams.phn_num = filterValue;
            break;
          case "first_name":
            queryParams.tech_name = filterValue;
            break;
          case "region":
            queryParams.region = filterValue;
            break;
          default:
            break;
        }
      }

      const response = await axios.get(`${BASE_URL}/api/tickets/`, {
        headers: HEADERS,
        params: queryParams,
      });

      if (response?.data) {
        let tickets = response.data.results || [];
        tickets = tickets.map((ticket) => ({
          ...ticket,
          startDateTime: moment(ticket.start_date_time).format(
            "YYYY-MM-DD HH:mm:ss",
          ),
          endDateTime: moment(ticket.end_date_time).format(
            "YYYY-MM-DD HH:mm:ss",
          ),
        }));

        setFilteredTickets(tickets);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllTicketIds = async () => {
    try {
      const queryParams = {
        page: 1,
        page_size: 100000,
        status: statusFilter || undefined,
      };

      if (filterType && filterValue && filterType !== "ticketid") {
        switch (filterType) {
          case "taskName":
            queryParams.task_name = filterValue;
            break;
          case "customer_name":
            queryParams.cust_name = filterValue;
            break;
          case "subcustomer_name":
            queryParams.subcust_name = filterValue;
            break;
          case "phone_number":
            queryParams.phn_num = filterValue;
            break;
          case "first_name":
            queryParams.tech_name = filterValue;
            break;
          case "region":
            queryParams.region = filterValue;
            break;
          default:
            break;
        }
      }

      const response = await axios.get(`${BASE_URL}/api/tickets/`, {
        headers: HEADERS,
        params: queryParams,
      });

      const tickets = response?.data?.results || [];
      setAllTicketIds(tickets.map((ticket) => ticket.id));
    } catch (error) {
      console.error("Error fetching all ticket IDs", error);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location?.search);
    const statusFromQuery = searchParams.get("status");
    const idFromQuery = searchParams.get("id");

    if (statusFromQuery) {
      setStatusFilter(statusFromQuery);
    }
    if (idFromQuery) {
      setFilterType("ticketid");
      setFilterValue(idFromQuery);
    }
  }, [location]);

  const handleCloseModals = () => {
    setShowTicketModal(false);
    setShowImportModal(false);
    setShowExportModal(false);
    setEditTicketData(null);
    setShowStatusModal(false);
    fetchTickets(currentPage);
  };

  const handleEditTicket = (ticket) => {
    setEditTicketData(ticket);
    setTicketAction("edit");
    setShowTicketModal(true);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleFilterTypeChange = (e) => {
    const selectedFilter = e.target.value;
    setFilterType(selectedFilter);
    setFilterValue("");

    setCurrentPage(1);
  };

  const handleFilterValueChange = (e) => {
    const value = e.target.value;
    setFilterValue(value);
    if (filterType) {
    }
    setCurrentPage(1);
  };

  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleSelectAll = async (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedTicketIds(allTicketIds);
    } else {
      setSelectedTicketIds([]);
    }
  };

  const handleSelectTicket = (ticketId) => {
    setSelectedTicketIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(ticketId)) {
        return prevSelectedIds.filter((id) => id !== ticketId);
      } else {
        return [...prevSelectedIds, ticketId];
      }
    });
  };

  const handleReassignTicket = (ticket) => {
    setEditTicketData(ticket);
    setTicketAction("reassign");
    setShowTicketModal(true);
  };

  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setShowViewModal(true);
  };
  const handleUpdateStatus = (ticket) => {
    setEditTicketData(ticket);
    setTicketAction("updateStatus");
    setShowStatusModal(true);
  };

  const handleDownloadTicket = async (ticketId) => {
    if (!ticketId) {
      toast.error("Ticket ID is missing. Please provide a valid ticket ID.");
      return;
    }

    setLoading(true);

    try {
      const url = `${BASE_URL}/api/ticket/${ticketId}/pdf/`;

      const mimeType = "application/pdf";
      const fileName = `Ticket_${ticketId}.pdf`;

      const response = await axios.get(url, {
        responseType: "blob",
        headers: HEADERS,
      });

      const blob = new Blob([response.data], { type: mimeType });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      toast.success("Ticket downloaded successfully!");
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const STATUS_CHOICES = [
    { value: "Inactive", label: "Inactive" },
    { value: "Not-Assigned", label: "Not-Assigned" },
    { value: "Accepted", label: "Accepted" },

    { value: "Rejected", label: "Rejected" },

    { value: "Ongoing", label: "Ongoing" },
    { value: "Completed", label: "Completed" },
    { value: "Autoclose", label: "Autoclose" },
    { value: "On-Hold", label: "On-Hold" },
  ];

  const handleDeleteTicket = async (ticketId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/tickets/${ticketId}/`,
        {
          headers: HEADERS,
        },
      );
      if (response) {
        toast.success("Ticket deleted successfully!");
        fetchTickets(currentPage);
      } else {
        toast.error("Failed to delete ticket. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);

        toast.error("Error Please Try again.");
      }
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex  container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 mt-3">
        <h4 className="mb-md-0">Tickets</h4>

        <div className="d-none d-md-flex align-items-center flex-wrap gap-2">
          <div className="me-2" style={{ minWidth: "180px" }}>
            <Form.Select
              value={statusFilter}
              onChange={handleStatusChange}
              disabled={currentItems.length === 0 && !statusFilter}
              className="common-input w-100"
            >
              <option value="">All Status</option>
              {STATUS_CHOICES.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </Form.Select>
          </div>

          <div style={{ minWidth: "180px" }}>
            <Form.Select
              value={filterType}
              onChange={handleFilterTypeChange}
              disabled={currentItems.length === 0 && !filterType}
              className="uniform-input w-100"
            >
              <option value="">Filter By</option>
              <option value="ticketid">Ticket Id</option>
              <option value="taskName">Task Name</option>
              <option value="customer_name">Customer Name</option>
              <option value="subcustomer_name">Sub Customer Name</option>
              <option value="phone_number">Phone number</option>
              <option value="first_name">Technician Name</option>
              <option value="region">Region</option>
            </Form.Select>
          </div>

          {filterType && (
            <>
              {filterType === "region" ? (
                <div style={{ minWidth: "180px" }}>
                  <Form.Select
                    value={filterValue}
                    onChange={handleFilterValueChange}
                    className="uniform-input w-100"
                  >
                    <option value="">Select Region</option>
                    <option value="North">North</option>
                    <option value="South">South</option>
                    <option value="East">East</option>
                    <option value="West">West</option>
                  </Form.Select>
                </div>
              ) : (
                <div style={{ minWidth: "200px" }}>
                  <Form.Control
                    type="text"
                    value={filterValue}
                    className="uniform-input search-text w-100"
                    placeholder="Search Here..."
                    onChange={handleFilterValueChange}
                  />
                </div>
              )}
            </>
          )}

          {userPermissions.includes("ticket_add_ticket") && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowTicketModal(true)}
            >
              <FaPlus style={{ marginRight: "6px" }} /> Add
            </CommonButton>
          )}
          {userPermissions.includes("ticket_import") && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowImportModal(true)}
            >
              <FaFileImport style={{ marginRight: "6px" }} /> Import
            </CommonButton>
          )}
          {userPermissions.includes("ticket_export") && (
            <CommonButton
              className="uniform-button"
              onClick={() => setShowExportModal(true)}
              disabled={currentItems.length === 0}
            >
              <FaFileExport style={{ marginRight: "6px" }} /> Export
            </CommonButton>
          )}
          {userPermissions.includes("ticket_export")}
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="pt-3">
                <div className="mb-3">
                  <Form.Group className="mb-2">
                    <Form.Select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      disabled={currentItems.length === 0 && !statusFilter}
                      className="uniform-input"
                    >
                      <option value="">All Status</option>
                      {STATUS_CHOICES.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Select
                      value={filterType}
                      onChange={handleFilterTypeChange}
                      disabled={currentItems.length === 0 && !filterType}
                      className="uniform-input"
                    >
                      <option value="">Filter By</option>
                      <option value="ticketid">Ticket ID</option>
                      <option value="taskName">Task Name</option>
                      <option value="customer_name">Customer Name</option>
                      <option value="subcustomer_name">
                        Sub Customer Name
                      </option>
                      <option value="phone_number">Phone Number</option>
                      <option value="first_name">Technician Name</option>
                      <option value="region">Region</option>
                    </Form.Select>
                  </Form.Group>

                  {filterType && (
                    <Form.Group className="mb-2">
                      <Form.Label className="fw-semibold small text-muted">
                        Value
                      </Form.Label>
                      {filterType === "region" ? (
                        <Form.Select
                          value={filterValue}
                          onChange={handleFilterValueChange}
                          className="uniform-input"
                        >
                          <option value="">Select Region</option>
                          <option value="North">North</option>
                          <option value="South">South</option>
                          <option value="East">East</option>
                          <option value="West">West</option>
                        </Form.Select>
                      ) : (
                        <Form.Control
                          type="text"
                          value={filterValue}
                          onChange={handleFilterValueChange}
                          placeholder="Search here..."
                          className="uniform-input search-text"
                        />
                      )}
                    </Form.Group>
                  )}
                </div>

                <div className="d-flex flex-wrap gap-2 justify-content-start mt-3">
                  {userPermissions.includes("ticket_add_ticket") && (
                    <CommonButton
                      className="uniform-button flex-fill"
                      onClick={() => setShowTicketModal(true)}
                    >
                      <FaPlus className="me-1" /> Add
                    </CommonButton>
                  )}

                  {userPermissions.includes("ticket_import") && (
                    <CommonButton
                      className="uniform-button flex-fill"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaFileImport className="me-1" /> Import
                    </CommonButton>
                  )}

                  {userPermissions.includes("ticket_export") && (
                    <CommonButton
                      className="uniform-button flex-fill"
                      onClick={() => setShowExportModal(true)}
                      disabled={currentItems.length === 0}
                    >
                      <FaFileExport className="me-1" /> Export
                    </CommonButton>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${
          currentItems.length === 0 ? "" : "tabell"
        } `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table  tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {userPermissions.includes("ticket_export") && (
                      <th style={{ width: "50px" }}>
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedTicketIds.length === allTicketIds.length &&
                            allTicketIds.length > 0
                          }
                        />
                      </th>
                    )}
                    <th style={{ width: "250px" }}>Ticket Id/Task Name</th>
                    <th style={{ width: "200px" }}>Customer Name</th>
                    <th style={{ width: "200px" }}>Sub Customer Name</th>
                    <th style={{ width: "200px" }}>Technician Name</th>
                    <th style={{ width: "200px" }}>Start Date/Time</th>
                    <th style={{ width: "200px" }}>End Date/Time</th>
                    <th style={{ width: "200px" }}>Time</th>
                    <th style={{ width: "300px" }}>Address</th>
                    <th style={{ width: "200px" }}>Phone No.</th>
                    <th style={{ width: "150px" }}>Region</th>
                    <th style={{ width: "200px" }}>Product Name</th>
                    <th style={{ width: "200px" }}>Model No.</th>
                    <th style={{ width: "250px" }}>Purpose</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "200px" }}>Ticket Date</th>
                    <th style={{ width: "200px" }}>Aging</th>
                    <th style={{ width: "100px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((ticket, index) => (
                    <tr
                      key={ticket.id}
                      onClick={() => handleViewTicket(ticket)}
                      className="tbody"
                    >
                      {userPermissions.includes("ticket_export") && (
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedTicketIds.includes(ticket.id)}
                            onChange={() => handleSelectTicket(ticket.id)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>
                      )}

                      <td>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2">
                            {ticket.id}
                          </span>
                          <div
                            title={ticket.taskName || "—"}
                            className="tdsubject"
                          >
                            {ticket.taskName || "—"}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          title={ticket?.customerDetails?.customer_name || "—"}
                          className="tdsubject"
                        >
                          {ticket?.customerDetails?.customer_name || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            ticket?.subCustomerDetails?.customer_name || "—"
                          }
                          className="tdsubject"
                        >
                          {ticket?.subCustomerDetails?.customer_name || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            `${ticket.assignTo?.first_name || ""} ${
                              ticket.assignTo?.last_name || ""
                            }`.trim() || "—"
                          }
                          className="tdsubject"
                        >
                          {ticket.assignTo?.first_name || "—"}{" "}
                          {ticket.assignTo?.last_name}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            moment(ticket.startDateTime).format(
                              "YYYY-MM-DD HH:mm:ss",
                            ) || "—"
                          }
                          className="tdsubject"
                        >
                          {moment(ticket.startDateTime).format("YYYY-MM-DD") ||
                            "—"}
                          <br />
                          <span className="badge bg-primary text-white">
                            {moment(ticket.startDateTime).format("HH:mm:ss") ||
                              "—"}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            moment(ticket.endDateTime).format(
                              "YYYY-MM-DD HH:mm:ss",
                            ) || "—"
                          }
                          className="tdsubject"
                        >
                          {moment(ticket.endDateTime).format("YYYY-MM-DD") ||
                            "—"}
                          <br />
                          <span className="badge bg-primary text-white">
                            {moment(ticket.endDateTime).format("HH:mm:ss") ||
                              "—"}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div
                          title={ticket.total_time || "—"}
                          className="tdsubject"
                        >
                          {ticket.total_time || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={ticket.ticket_address || "—"}
                          className="tdsubject"
                        >
                          {ticket.ticket_address || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={ticket.phone_number || "—"}
                          className="tdsubject"
                        >
                          {ticket.phone_number || "—"}
                        </div>
                      </td>

                      <td>
                        <div title={ticket.region || "—"} className="tdsubject">
                          {ticket.region || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={ticket.product_name?.name || "—"}
                          className="tdsubject"
                        >
                          {ticket.product_name?.name || "—"}
                        </div>
                      </td>
                      <td>
                        <div title={ticket.model || "—"} className="tdsubject">
                          {ticket.model || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={ticket.purpose || "—"}
                          className="tdsubject"
                        >
                          {ticket.purpose || "—"}
                        </div>
                      </td>

                      <td>
                        <StatusBadge status={ticket.status} />
                      </td>

                      <td>
                        <div title={ticket.date || "—"} className="tdsubject">
                          {ticket.date || "—"}
                          <br />
                          <span className="badge bg-primary text-white">
                            FSR: {ticket?.fsrDetails?.fsrName || "—"}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div title={ticket.aging || "0"} className="tdsubject">
                          {ticket?.aging || "0"} Days{" "}
                        </div>
                      </td>

                      <td>
                        <div className="ms-auto">
                          <DropdownButton
                            id="dropdown-basic-button"
                            title={<BsThreeDotsVertical />}
                            variant="link"
                            className="p-0 text-secondary custom-dropdown"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {userPermissions.includes("ticket_download") &&
                              (ticket.status === "Completed" ||
                                ticket.status === "Rejected") && (
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownloadTicket(ticket.id);
                                  }}
                                >
                                  {loading ? (
                                    <span>
                                      <Spinner
                                        animation="border"
                                        size="sm"
                                        className="me-2"
                                      />{" "}
                                      Downloading...
                                    </span>
                                  ) : (
                                    <span>
                                      <FaDownload className="me-2" /> Download
                                    </span>
                                  )}
                                </Dropdown.Item>
                              )}

                            {userPermissions.includes(
                              "ticket_update_status",
                            ) && (
                              <>
                                {ticket.status !== "Completed" &&
                                  ticket.status !== "Rejected" && (
                                    <Dropdown.Item
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleUpdateStatus(ticket);
                                      }}
                                    >
                                      <FaEdit className="me-2" /> Update Status
                                    </Dropdown.Item>
                                  )}
                              </>
                            )}
                            {userPermissions.includes("ticket_reassign") &&
                              (ticket.status === "Completed" ||
                                ticket.status === "Rejected") && (
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleReassignTicket(ticket);
                                  }}
                                >
                                  <FaEdit className="me-2" /> Reassign
                                </Dropdown.Item>
                              )}

                            {userPermissions.includes(
                              "ticket_change_ticket",
                            ) && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditTicket(ticket);
                                }}
                              >
                                <FaEdit className="me-2" /> Edit
                              </Dropdown.Item>
                            )}
                            {userPermissions.includes(
                              "ticket_delete_ticket",
                            ) && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteTicket(ticket.id);
                                }}
                              >
                                <span className="d-flex align-items-center text-danger">
                                  <FaTrashAlt className="me-2" /> Delete
                                </span>
                              </Dropdown.Item>
                            )}
                          </DropdownButton>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showTicketModal && (
        <TicketComponent
          show={showTicketModal}
          handleClose={handleCloseModals}
          ticket={editTicketData}
          fetchTickets={() => fetchTickets(currentPage)}
          action={ticketAction}
          setTicketAction={setTicketAction}
        />
      )}

      {showStatusModal && (
        <UpdateTicketsStatus
          show={showStatusModal}
          handleClose={handleCloseModals}
          ticket={editTicketData}
          fetchTickets={() => fetchTickets(currentPage)}
          action={ticketAction}
          setTicketAction={setTicketAction}
        />
      )}
      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="tickets"
          onSuccess={() => fetchTickets(currentPage)}
        />
      )}

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        selectedTicketIds={selectedTicketIds}
        title="tickets"
        setSelectedTicketIds={setSelectedTicketIds}
      />

      <TicketViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        ticketId={selectedTicket?.id}
        ticket={selectedTicket}
      />
    </div>
  );
}

export default Tickets;
